var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 682.447,
    height: 561.908,
    viewBox: "0 0 682.447 561.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2.4,
    y1: 2.198,
    x2: 0.44,
    y2: -0.304,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#273fc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a6305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#9a6305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2.4,
    y1: 2.198,
    x2: 0.44,
    y2: -0.304,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#273fc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a6305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.038,
    stopColor: "#241700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#9a6305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a6305"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2.4,
    y1: 2.198,
    x2: 1.844,
    y2: -1.272,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a6305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#9a6305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858,
    stopColor: "#9a6305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a6305"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32454",
    "data-name": "Group 32454",
    transform: "translate(-244 -6978.927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32010",
    "data-name": "Group 32010",
    transform: "translate(-22037.316 8048.202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32008",
    "data-name": "Group 32008",
    transform: "translate(22281.316 -1069.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29243",
    "data-name": "Path 29243",
    d: "M541.553,546.461,201.9,350.676c-17.392-10.03-31.429-36.776-31.429-59.967V31.611C170.473,8.627,184.51-2.03,201.9,8L541.553,203.784c17.39,10.03,31.429,36.776,31.429,59.969v259.1C572.982,545.834,558.943,556.491,541.553,546.461Z",
    transform: "translate(98.567 1.677)",
    fill: "#9a6305",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29244",
    "data-name": "Path 29244",
    d: "M545.052,530.264l-345.1-198.919c-14.457-9.193-23.259-27.372-23.259-45.969V16.667a5.807,5.807,0,0,1,8.592-5.015,4.567,4.567,0,0,1,1.046.627L531.852,211.407c17.181,9.821,23.257,27.372,23.257,45.969V525.249a6.214,6.214,0,0,1-9.218,5.433C545.471,530.473,545.261,530.264,545.052,530.264Z",
    transform: "translate(111.621 4.534)",
    fill: "rgba(167,107,5,0.08)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29257",
    "data-name": "Path 29257",
    d: "M531.852,211.463,186.333,12.334a4.581,4.581,0,0,0-1.046-.627,5.672,5.672,0,0,0-8.592,5.015V285.431c0,18.6,9.011,36.983,23.259,45.969l345.1,198.919c.209,0,.418.209.839.418a6.174,6.174,0,0,0,9.218-5.433V257.431C555.109,238.834,549.032,221.283,531.852,211.463ZM551.547,525.3a2.411,2.411,0,0,1-2.514,2.506,3.013,3.013,0,0,1-1.257-.416L201.84,328.056c-12.991-8.149-21.583-25.074-21.583-42.835V16.722a2.1,2.1,0,0,1,2.1-2.09,1.894,1.894,0,0,1,1.048.209L529.965,214.6c17.81,10.239,21.581,29.043,21.581,42.835Z",
    transform: "translate(104.287 7.79)",
    fill: "#9a6305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29271",
    "data-name": "Path 29271",
    d: "M546.939,200.552,207.287,4.976c-6.915-3.97-13.2-4.806-18.438-2.716-.63.209-11.525,6.268-12.154,6.686,5.449-2.507,12.154-2.089,19.488,2.089L535.832,206.82c17.392,10.03,31.431,36.776,31.431,59.969v259.1c0,14.417-5.449,24.028-13.83,26.746a6.317,6.317,0,0,0,2.723-.837c.42-.209,11.943-6.9,12.363-7.312,6.076-4.18,9.638-12.747,9.638-24.656v-259.1C578.367,237.537,564.328,210.582,546.939,200.552Z",
    transform: "translate(104.287 -1.149)",
    fill: "#9a6305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29280",
    "data-name": "Path 29280",
    d: "M536.406,203.339,196.754,7.762c-7.124-4.179-13.619-4.6-18.858-2.507,4.4-.627,9.64.418,15.087,3.552L532.634,204.592c17.39,10.03,31.429,36.774,31.429,59.967v259.1c0,13.58-4.819,22.775-12.571,26.118,9.638-1.462,16.342-11.492,16.342-27.164v-259.1C567.834,240.113,553.586,213.369,536.406,203.339Z",
    transform: "translate(105.391 1.497)",
    fill: "#9a6305",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31993",
    "data-name": "Group 31993",
    transform: "translate(122.158 136.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29371",
    "data-name": "Path 29371",
    d: "M122.016,72.5l28.078,16.089-28.078,16.3-28.077-16.3Z",
    transform: "translate(-93.939 -72.495)",
    fill: "#717171",
    opacity: 0.53
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31995",
    "data-name": "Group 31995",
    transform: "translate(122.158 153.016)",
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31994",
    "data-name": "Group 31994",
    transform: "translate(28.077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29372",
    "data-name": "Path 29372",
    d: "M136.647,303.2l-28.078,16.089V96.967l28.078-16.089Z",
    transform: "translate(-108.569 -80.878)",
    fill: "#717171",
    opacity: 0.53
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29373",
    "data-name": "Path 29373",
    d: "M122.016,319.288,93.939,303.2V80.878l28.077,16.089Z",
    transform: "translate(-93.939 -80.878)",
    fill: "#717171"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31999",
    "data-name": "Group 31999",
    transform: "translate(81.927 209.851)",
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31996",
    "data-name": "Group 31996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29374",
    "data-name": "Path 29374",
    d: "M101.055,110.492l28.077,16.089-28.077,16.3-28.077-16.3Z",
    transform: "translate(-72.977 -110.492)",
    fill: "#717171"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31998",
    "data-name": "Group 31998",
    transform: "translate(0 16.089)",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31997",
    "data-name": "Group 31997",
    transform: "translate(28.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29375",
    "data-name": "Path 29375",
    d: "M115.684,290.63,87.607,306.721V135.173l28.077-16.3Z",
    transform: "translate(-87.607 -118.875)",
    fill: "#717171",
    opacity: 0.53
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29376",
    "data-name": "Path 29376",
    d: "M101.055,306.721,72.977,290.63V118.875l28.077,16.3Z",
    transform: "translate(-72.977 -118.875)",
    fill: "#717171"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32003",
    "data-name": "Group 32003",
    transform: "translate(40.65 281.31)",
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32000",
    "data-name": "Group 32000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29377",
    "data-name": "Path 29377",
    d: "M79.547,147.726l28.077,16.089-28.077,16.3-28.077-16.3Z",
    transform: "translate(-51.47 -147.726)",
    fill: "#717171"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32002",
    "data-name": "Group 32002",
    transform: "translate(0 16.091)",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32001",
    "data-name": "Group 32001",
    transform: "translate(28.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29378",
    "data-name": "Path 29378",
    d: "M94.177,278.135,66.1,294.225V172.408l28.077-16.3Z",
    transform: "translate(-66.1 -156.11)",
    fill: "#717171",
    opacity: 0.53
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29379",
    "data-name": "Path 29379",
    d: "M79.547,294.225,51.47,278.135V156.11l28.077,16.3Z",
    transform: "translate(-51.47 -156.11)",
    fill: "#717171"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32007",
    "data-name": "Group 32007",
    transform: "translate(0 355.278)",
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32004",
    "data-name": "Group 32004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29380",
    "data-name": "Path 29380",
    d: "M58.366,186.267l28.077,16.3L58.366,218.654,30.289,202.565Z",
    transform: "translate(-30.289 -186.267)",
    fill: "#717171"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29381",
    "data-name": "Path 29381",
    d: "M58.366,224.046l28.077,16.3-28.077,16.3-28.077-16.3Z",
    transform: "translate(-30.289 -151.54)",
    fill: "#717171",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32006",
    "data-name": "Group 32006",
    transform: "translate(0 16.298)",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32005",
    "data-name": "Group 32005",
    transform: "translate(28.077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29382",
    "data-name": "Path 29382",
    d: "M73,267.892,44.919,283.981V210.848L73,194.759Z",
    transform: "translate(-44.919 -194.759)",
    fill: "#717171",
    opacity: 0.53
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29383",
    "data-name": "Path 29383",
    d: "M58.366,283.981,30.289,267.892V194.759l28.077,16.089Z",
    transform: "translate(-30.289 -194.759)",
    fill: "#717171"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_29384",
    "data-name": "Path 29384",
    d: "M177.25,137.71l6.915,44.925-2.723,40.117-11.734-23.819Z",
    transform: "translate(97.864 124.377)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29385",
    "data-name": "Path 29385",
    d: "M180.517,166.775V204.8l4.4-2.508V164.057Z",
    transform: "translate(107.8 148.596)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29386",
    "data-name": "Path 29386",
    d: "M202.8,178.283v38.029l-46.517-26.537V151.537Z",
    transform: "translate(85.52 137.087)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29387",
    "data-name": "Path 29387",
    d: "M156.279,152.838,202.8,179.584l4.4-2.718-46.306-26.744Z",
    transform: "translate(85.52 135.787)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29388",
    "data-name": "Path 29388",
    d: "M195.872,187.234l.418-12.747,3.98-2.925-4.61,2.09-31.849-17.76,31.431,18.386Z",
    transform: "translate(92.445 141.09)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29389",
    "data-name": "Path 29389",
    d: "M200.718,229.381a21.217,21.217,0,0,1-2.3,7.732c-1.048,1.879-1.259,4.178-2.3,3.76s.209-9.4.209-9.4Z",
    transform: "translate(121.749 208.642)",
    fill: "#f2bba2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29390",
    "data-name": "Path 29390",
    d: "M175.846,180.28c2.514,1.044,3.144,2.088,3.771,3.552.839,1.462,1.887,3.134,1.887,3.134s-1.466-.209-3.144-.628-7.124-2.925-7.124-2.925Z",
    transform: "translate(99.269 163.508)",
    fill: "#ffd4c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29391",
    "data-name": "Path 29391",
    d: "M165.194,131.287c-5.449,1.253-11.945.209-7.124,14.417,3.98,11.283.209,67.072,3.351,88.176.839,5.224,12.991,6.687,12.991,6.687s14.878-49.312,14.668-64.147-7.544-40.535-7.544-40.535Z",
    transform: "translate(85.616 118.473)",
    fill: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29392",
    "data-name": "Path 29392",
    d: "M168.16,143.57l1.885-2.3-3.771-3.343h-.839l-2.933,4.6,2.3,1.462,3.144,47.224,2.3,23.4A79.315,79.315,0,0,0,173.818,191C174.027,176.585,168.16,143.57,168.16,143.57Z",
    transform: "translate(91.241 124.578)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29393",
    "data-name": "Path 29393",
    d: "M163.283,243.29l-.628,3.762a3.933,3.933,0,0,0,2.3,4.387,5.438,5.438,0,0,0,2.094.837c1.468.416,11.525,6.687,15.925,7.521,4.61.837,7.752-.626,7.752-1.881s-1.048-3.343-5.237-6.059-7.754-9.193-7.754-9.193Z",
    transform: "translate(91.296 220.851)",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29394",
    "data-name": "Path 29394",
    d: "M162.829,247.27c.63.835,6.5,1.881,9.429,4.178,3.144,2.508,8.59,6.268,12.152,6.9,3.353.628,5.867-1.044,5.449-2.3-.418-1.879-3.353-3.343-6.076-5.431s-5.449-6.686-5.449-6.686l-14.876-1.046Z",
    transform: "translate(91.541 221.051)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29395",
    "data-name": "Path 29395",
    d: "M185.33,179.953s3.98,59.967,3.98,65.61c0,3.552-5.238,51.611-5.658,55.789s-15.294,3.552-15.085-.628c0-3.134,1.257-49.938,1.257-49.938l-12.782-62.476,2.3-6.268Z",
    transform: "translate(86.223 163.207)",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29396",
    "data-name": "Path 29396",
    d: "M146.125,251.265v3.969A5.027,5.027,0,0,0,147.591,259l1.257,1.253a29.968,29.968,0,0,0,8.172,7.731c4.61,2.927,10.268,2.3,11.734,1.255s1.466-2.09-2.1-6.686c-3.353-4.6-8.381-11.283-8.381-11.283Z",
    transform: "translate(76.187 228.757)",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29397",
    "data-name": "Path 29397",
    d: "M146.435,254.625s5.028,4.6,6.706,7.314c2.723,4.178,9.638,7.312,14.037,5.641,4.61-1.462-1.675-6.268-2.933-8.356s-4.819-7.314-4.819-7.314l-13.409-.209Z",
    transform: "translate(76.088 229.157)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29398",
    "data-name": "Path 29398",
    d: "M176.031,182.259s-12.573,132.475-13.621,135.818c-.837,2.925-13.828,2.925-14.039-2.09-.209-5.224-3.351-109.488-3.98-114.713a88.406,88.406,0,0,1-.209-21.1Z",
    transform: "translate(73.94 163.408)",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29399",
    "data-name": "Path 29399",
    d: "M155.954,137.466c-.209,4.18,5.449,11.283,10.686,13.791.209.209,5.449-6.687,5.449-6.687s6.495,5.433,6.495,5.224a31.477,31.477,0,0,0,1.887-10.867c.209-3.969-5.028-7.312-11.734-7.731C161.821,130.78,156.163,133.5,155.954,137.466Z",
    transform: "translate(85.216 118.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29400",
    "data-name": "Path 29400",
    d: "M208.288,175.193s-10.266-1.046-14.248.835-10.686,8.358-10.686,10.448c0,1.881,5.449,4.178,8.8,3.343s3.771-1.462,6.285-2.09a63.178,63.178,0,0,0,10.059-3.343C210.384,183.551,208.288,175.193,208.288,175.193Z",
    transform: "translate(110.408 158.565)",
    fill: "#ffd4c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29401",
    "data-name": "Path 29401",
    d: "M166.65,130.525a18.432,18.432,0,0,1,11.316,5.015c3.353,3.551,3.98,15.879,4.19,20.058,0,4.18-.418,51.611-1.046,61.85-.42,8.149-1.048,16.089-1.257,20.476-.42,5.224-10.059,7.523-11.106,4.806s.839-25.491,2.1-34.267c1.048-7.312,1.466-48.266.628-66.863C171.051,133.241,166.65,130.525,166.65,130.525Z",
    transform: "translate(95.053 117.773)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29402",
    "data-name": "Path 29402",
    d: "M176.453,131.178s-7.963,1.672-6.076,7.731,7.333,16.3,11.314,30.508c4.4,16.507,3.562,66.028.839,74.386-1.887,5.641-41.069,6.268-40.439-5.015.209-3.552,2.3-81.282,4.19-87.132,2.516-7.942,14.668-13.164,22.631-17.344A47.923,47.923,0,0,1,176.453,131.178Z",
    transform: "translate(72.471 118.373)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29403",
    "data-name": "Path 29403",
    d: "M146.919,175.38s4.4,1.253,8.8,2.09,9.847,1.672,9.847,1.672.209,5.224-2.3,5.642-15.924-1.672-16.971-3.136C145.243,179.976,146.919,175.38,146.919,175.38Z",
    transform: "translate(76.023 159.004)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29404",
    "data-name": "Path 29404",
    d: "M183.473,172.758s2.3,1.881,4.192,2.09,7.961,0,9.847.628,7.963,2.507,7.963,3.969c.209,1.672-2.1.628-3.773.209-1.675-.209-4.608-.418-4.608-.418a43.192,43.192,0,0,0,5.656,4.806c2.1,1.255,5.658,1.881,6.287,3.136s-.211,2.3-1.887,3.551c-2.723,1.881-4.819,1.255-7.124,1.255a18.339,18.339,0,0,1-10.477-2.927c-1.885-1.462-7.124-5.641-8.172-6.268-1.257-.626-5.447-2.3-5.447-2.3l7.124-7.942Z",
    transform: "translate(103.584 156.402)",
    fill: "#ffd4c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29405",
    "data-name": "Path 29405",
    d: "M207.26,188.935c1.677-1.253,2.514-2.3,1.887-3.551q0-.314-.629-.628c-1.466,1.881-6.076,2.716-9.009,2.09-3.144-.628-11.106-6.061-13.409-8.358-1.259-1.046-5.03-2.508-8.592-3.762l-1.466,3.762s4.192,1.672,5.449,2.3,6.285,4.808,8.172,6.27a18.343,18.343,0,0,0,10.475,2.925C202.44,190.19,204.536,190.816,207.26,188.935Z",
    transform: "translate(103.685 158.404)",
    fill: "#f1d5be",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29406",
    "data-name": "Path 29406",
    d: "M196.874,179.037a6.612,6.612,0,0,0-1.677,5.852,8.758,8.758,0,0,0,2.3,5.431l38.555-.418s28.915,1.046,27.658-10.655c-1.257-11.283-9.009-10.657-25.562-6.268C221.39,177.156,196.874,179.037,196.874,179.037Z",
    transform: "translate(121.194 154.094)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29407",
    "data-name": "Path 29407",
    d: "M184.359,177.413c-.629.628-.209,2.3,1.675,2.508s6.287-.209,7.963-.209,9.638-3.134,9.638-3.134Z",
    transform: "translate(111.08 160.105)",
    fill: "#f1d5be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29408",
    "data-name": "Path 29408",
    d: "M194.149,175.163c-1.887,1.044-4.819,1.672-6.5,2.507-1.466.837-2.932.418-3.351,1.044s-.211,2.718,3.771,1.881,6.076-1.462,8.381-1.253,6.915,0,7.752-1.253-.837-2.925-.837-2.925Z",
    transform: "translate(111.139 158.804)",
    fill: "#ffd4c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29409",
    "data-name": "Path 29409",
    d: "M182.5,181.209c-.418-.837,3.562-.628,4.61-.209a57.232,57.232,0,0,1,6.285,2.716c.629.418,1.675,1.046-.839,1.255C187.733,185.387,183.962,183.924,182.5,181.209Z",
    transform: "translate(109.59 163.833)",
    fill: "#ffd4c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29410",
    "data-name": "Path 29410",
    d: "M177.5,128.289c.42-2.508-2.933-5.015-7.333-5.642s-8.172.837-8.59,3.343l-4.192,18.388c-.418,3.134,3.562,6.059,8.8,6.9s9.847-1.046,10.266-4.18Z",
    transform: "translate(86.509 110.398)",
    fill: "#ffd4c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29411",
    "data-name": "Path 29411",
    d: "M161.017,135.174a29.391,29.391,0,0,1-.839-10.865c1.468-1.462,4.4-2.09,7.544-1.672,4.4.628,7.542,3.134,7.333,5.642,0,0-.839,18.8-1.048,18.8a3.741,3.741,0,0,1-.839,1.881C167.512,146.666,162.693,139.98,161.017,135.174Z",
    transform: "translate(88.954 110.406)",
    fill: "#f1d5be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29412",
    "data-name": "Path 29412",
    d: "M182.383,122.224c3.771,6.9.418,29.671-6.706,29.671s-14.039-8.775-15.924-14.417c-1.887-5.85-1.887-17.969,4.4-21.1C170.44,113.449,178.611,115.121,182.383,122.224Z",
    transform: "translate(87.704 103.506)",
    fill: "#ffd4c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29413",
    "data-name": "Path 29413",
    d: "M244.393,289.591s.839,3.552.209,5.015-3.98,2.716-6.495,1.462-3.771-3.971-4.819-4.6-6.5-1.255-10.686-4.808-3.562-7.312.628-7.521,11.734,1.881,14.459,3.552C240.2,284.367,244.393,289.591,244.393,289.591Z",
    transform: "translate(143.868 254.369)",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29414",
    "data-name": "Path 29414",
    d: "M241.928,293.32c-2.934.626-6.706-1.881-8.592-3.343-1.675-1.462-4.819-.628-8.8-3.762s-5.449-5.433-3.562-6.477,8.59-.837,13.619,2.09c5.239,2.716,8.592,4.806,8.592,4.806s1.257,3.76.628,4.806C243.395,292.065,243.6,292.9,241.928,293.32Z",
    transform: "translate(144.239 254.402)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29415",
    "data-name": "Path 29415",
    d: "M242.719,212.506s4.819,2.925,3.98,14.208c-.209,3.134,1.257,124.533,1.257,124.533s-4.4,1.672-6.495.837c-2.934-1.046-7.333-4.6-7.333-4.6L216.107,221.7Z",
    transform: "translate(140.514 193.13)",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29416",
    "data-name": "Path 29416",
    d: "M228.761,294.476s1.675,4.6-.418,5.433a9.915,9.915,0,0,1-7.754.417c-2.514-1.044-3.562-2.088-6.495-2.088-2.725,0-13.411-4.808-15.507-7.1s0-5.015,5.03-4.806c5.028.418,12.362.835,13.619,1.253C218.7,288.208,228.761,294.476,228.761,294.476Z",
    transform: "translate(123.67 260.976)",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29417",
    "data-name": "Path 29417",
    d: "M225.871,297.79c-4.819.418-6.285-.626-10.686-1.462s-16.971-5.431-16.762-7.94,3.144-2.088,5.449-1.881c2.514.209,10.268.628,10.9.628s13.2,5.224,13.2,5.224.839,3.762,0,4.387C227.128,297.165,227.128,297.583,225.871,297.79Z",
    transform: "translate(124.256 261.004)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29418",
    "data-name": "Path 29418",
    d: "M241.224,208.369s6.076,10.237,2.3,24.865c-3.771,14.835-19.906,71.46-19.906,71.46s.839,53.7.839,60.8c0,2.09-4.61,3.134-9.429,1.462-6.076-1.881-5.867-3.552-6.285-6.477-.209-2.507-6.915-49.1-6.5-62.685.839-17.969,4.192-72.506,4.192-72.506Z",
    transform: "translate(127.76 189.327)",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29419",
    "data-name": "Path 29419",
    d: "M245.85,168.728c6.078,1.044,12.154,2.925,13.2,17.342.837,11.911,3.562,90.893,3.562,90.893s-10.686,9.821-38.973,8.777c-19.278-.628-19.488-5.433-19.488-5.433s-1.048-48.894-1.466-75.012c-.209-12.12,1.466-15.254,5.449-18.6a219.238,219.238,0,0,1,18.438-12.745C231.6,170.818,240.613,167.684,245.85,168.728Z",
    transform: "translate(128.163 152.701)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29420",
    "data-name": "Path 29420",
    d: "M211.522,177.428c.211,3.134,5.239,5.224,11.316,4.806s10.686-3.134,10.686-6.268c-.209-3.134-5.237-5.224-11.316-4.806S211.522,174.294,211.522,177.428Z",
    transform: "translate(136.3 155.075)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29421",
    "data-name": "Path 29421",
    d: "M236.74,192.471a2.566,2.566,0,0,1-.42,2.09c-.837,1.253-4.19,3.762-9.009,3.762a15.047,15.047,0,0,1-8.381-1.672,3.25,3.25,0,0,1-1.257-1.672l-1.257-6.477s-5.03.416-6.5-1.464-7.333-25.491-.418-31.55,22.629-5.015,25.353,5.641c2.934,10.657-1.885,16.716-2.3,19.225C232.548,182.65,235.692,189.755,236.74,192.471Z",
    transform: "translate(131.408 137.316)",
    fill: "#ffd4c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29422",
    "data-name": "Path 29422",
    d: "M235.256,183.313s-5.658,2.09-7.963,1.462c-4.4-1.044-4.4-11.074-7.333-13.164-1.675-1.253-3.144.209-2.934,2.09.211,1.462-.209,2.506-.628,2.716-.63.209-3.562-8.358-3.562-8.358s-11.734-5.431-8.59-15.252c3.771,2.506,27.658-9.821,34.782,7.312C244.475,173.492,237.979,182.478,235.256,183.313Z",
    transform: "translate(129.119 136.445)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29423",
    "data-name": "Path 29423",
    d: "M205.081,244.718v38.029l4.4-2.716V241.793Z",
    transform: "translate(130.379 220.051)",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29424",
    "data-name": "Path 29424",
    d: "M227.36,256.127v38.029L180.844,267.41V229.381Z",
    transform: "translate(108.1 208.642)",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29425",
    "data-name": "Path 29425",
    d: "M197.265,252.106v2.506a1.234,1.234,0,0,1-1.885,1.046l-3.562-2.09a2.3,2.3,0,0,1-1.257-2.09V249.6a1.178,1.178,0,0,1,1.885-1.044l4.192,2.3A1.8,1.8,0,0,1,197.265,252.106Z",
    transform: "translate(117.032 226.035)",
    fill: "#6d4500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29426",
    "data-name": "Path 29426",
    d: "M227.36,256.027v11.492a2.769,2.769,0,0,1-2.723,2.716H205.778a7.831,7.831,0,0,1-5.449-2.507l-17.181-21.522a10.631,10.631,0,0,1-2.3-6.477V229.49Z",
    transform: "translate(108.1 208.742)",
    fill: "#6d4500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29427",
    "data-name": "Path 29427",
    d: "M180.844,230.782l46.516,26.746,4.4-2.925-46.517-26.746Z",
    transform: "translate(108.1 207.241)",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29428",
    "data-name": "Path 29428",
    d: "M201.329,233.156l-6.076-3.552a4.182,4.182,0,0,0-3.771-.416l-1.466.835.209,1.046a3.09,3.09,0,0,0-.209,1.462V236.5l1.257.837.418,1.881,1.466-.837v-3.552c0-1.672,1.257-2.3,2.514-1.462l4.819,2.718a5.67,5.67,0,0,1,2.516,4.387v3.552l1.466.835.209,1.881,1.466-.835v-3.971C206.568,238.8,204.263,234.827,201.329,233.156Z",
    transform: "translate(116.53 208.21)",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29429",
    "data-name": "Path 29429",
    d: "M189.359,233.131V237.1l3.144,1.881V235.43c0-1.672,1.257-2.3,2.514-1.462l4.819,2.716a5.676,5.676,0,0,1,2.514,4.387v3.552l3.144,1.881v-3.971a11.312,11.312,0,0,0-5.237-8.984L194.178,230C191.664,228.535,189.359,229.788,189.359,233.131Z",
    transform: "translate(115.927 208.653)",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29431",
    "data-name": "Path 29431",
    d: "M198.466,224.7a84.565,84.565,0,0,0-6.5,9.193c-1.048,1.881-1.048,2.3-.628,6.477.209,1.881.628,3.343,1.675,3.343.418,0,.209-1.044.209-1.044s.209,1.881,1.466,2.09.629-1.255.629-1.255.418,2.09,1.675,2.3.63-1.462.63-1.462.418,2.09,1.466,2.506,1.257-.209,1.257-1.672c0-1.672.839-3.134,2.3-5.85,1.675-2.925,2.934-4.18,2.723-6.9s2.1-5.015,2.1-5.015Z",
    transform: "translate(117.508 204.339)",
    fill: "#ffd4c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29432",
    "data-name": "Path 29432",
    d: "M216.263,179.929c6.915-2.3,13.621,1.881,15.3,8.986s-1.885,34.477-4.61,42-23.677,42-23.677,42a21.125,21.125,0,0,1-6.076-1.462c-2.933-1.253-3.142-2.925-3.142-2.925s10.9-32.6,13.2-39.284c2.3-6.894,2.1-25.7,2.933-33.431C210.816,186.616,209.559,182.228,216.263,179.929Z",
    transform: "translate(120.243 162.604)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29433",
    "data-name": "Path 29433",
    d: "M148.659,140.319c-7.752,3.762-5.237,15.67-1.466,23.612,2.3,5.222,5.658,13.371,7.542,18.386,1.887,5.224,6.5,16.925,11.943,19.85s43.165,12.538,43.165,12.538l4.819-11.076L176.946,185.66s-6.285-20.894-8.381-26.328C165,149.931,161.232,134.26,148.659,140.319Z",
    transform: "translate(73.862 125.53)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29434",
    "data-name": "Path 29434",
    d: "M179.345,131.282c8.59.416,10.475-3.971,9.009-8.776-1.257-3.971-9.429-10.03-21.163-8.776-11.523,1.255-10.057,14.419-9.847,19.641s1.048,9.613,2.723,8.149-.209-7.312,1.887-8.356c1.048-.418,2.1.626,2.514,2.088.418,2.3-1.048,8.776.629,11.283,1.675,2.927,9.218,9.195,13.828,6.9,4.819-2.506,5.239-8.775,5.239-8.775a11.942,11.942,0,0,0-3.773-.628,20.575,20.575,0,0,0-7.542,2.507s-5.238-2.507-5.447-4.6c-.211-1.253.837-7.731,1.885-12.536Q170.858,130.654,179.345,131.282Zm-1.468,14.835c.211,0,2.1-.209,2.3-.209,2.3-.209,1.677,1.462,1.677,1.462s-.209.628-2.725,1.044a6.549,6.549,0,0,1-3.142-.209A2.23,2.23,0,0,1,177.876,146.118Z",
    transform: "translate(86.341 102.18)",
    fill: "#1a1a1a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractsvg);
export default __webpack_public_path__ + "static/media/contractsvg.fb0b0d1e7f1caad491e7cc65acd4469c.svg";
export { ForwardRef as ReactComponent };